var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getSamples from "../../requests/metrics/getSamples";
import { TimezoneType } from "../../data/TimezoneType";
/**
 *
 */
var GetSamplesCommand = /** @class */ (function (_super) {
    __extends(GetSamplesCommand, _super);
    function GetSamplesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param organisation OrganisationModel
     * @param sampleCollection SampleCollection
     * @param sampleMetaDataCollection SampleMetaDataCollection
     * @param assetIDs Array metricsDbIds
     * @param measurementIDs Array
     * @param interval
     * @param timeRange
     * @param timezone
     * @return {*}
     */
    GetSamplesCommand.prototype.execute = function (organisation, sampleCollection, sampleMetaDataCollection, assetIDs, measurementIDs, interval, timeRange, timezone) {
        if (timezone === void 0) { timezone = TimezoneType["Europe/Amsterdam"]; }
        this.sampleCollection = sampleCollection;
        this.sampleMetaDataCollection = sampleMetaDataCollection;
        var promise = getSamples(organisation, assetIDs, measurementIDs, interval, timeRange, timezone);
        promise.then(this.then);
        return promise;
    };
    GetSamplesCommand.prototype.then = function (response) {
        // assetData
        var samples = [];
        Object.keys(response.assetData).forEach(function (assetMetricsId) {
            Object.keys(response.assetData[assetMetricsId]).forEach(function (measurementId) {
                return response.assetData[assetMetricsId][measurementId].forEach(function (sample) {
                    samples.push({
                        assetMetricsId: assetMetricsId,
                        measurementId: measurementId,
                        timestamp: sample[0],
                        sampleValue: sample[1],
                        path: sample[2],
                        metadataRefId: sample[3],
                        aggregateFields: sample[4]
                    });
                });
            });
        });
        this.sampleCollection.reset();
        this.sampleCollection.addAll(samples);
        // metadataDefinitions
        var sampleMetaData = Object.keys(response.metadataDefinitions).map(function (metaDataId) {
            return response.metadataDefinitions[metaDataId];
        });
        this.sampleMetaDataCollection.reset();
        this.sampleMetaDataCollection.addAll(sampleMetaData);
    };
    return GetSamplesCommand;
}(Command));
export default GetSamplesCommand;
